'use strict';

var UserUtils = require('../UserUtils');
var ChatUtils = require('../ChatUtils');
var TeamUtils = require('../TeamUtils');
var FirebaseUtils = require('../FirebaseUtils');

var CreateRoom = {
  getSchema: function getSchema() {
    return {
      "definitions": {
        "room": {
          "type": "object",
          "properties": {
            "title": { "type": "string", "default": "" }
          },
          "required": ["title"]
        },
        "team": {
          "type": "object",
          "properties": {
            "id": { "type": "string" }
          },
          "required": ["id"]
        },
        "members": {
          "items": {
            "type": "object",
            "properties": {
              "userId": { "type": "string" },
              "displayName": { "type": "string" },
              "access": { "type": "string" }
            },
            "required": ["userId", "displayName", "access"]
          }
        }
      },

      "properties": {
        "room": { "$ref": "#/definitions/room" },
        "team": { "$ref": "#/definitions/team" },
        "members": { "$ref": "#/definitions/members" }
      },
      "required": ["room", "team", "members"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    var updates = {};
    var dbRef = fbApp.database().ref();

    body.room.id = dbRef.child('rooms').push().key;
    ChatUtils.createRoom(updates, timestamp, body.room, body.team);
    ChatUtils.addUsersToRoom(updates, timestamp, body.room, body.team, body.members);

    // Save to firebase
    FirebaseUtils.saveToFirebase(dbRef, updates, callback, { roomId: body.room.id });
  }
};

module.exports = CreateRoom;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/CreateRoom.js
// module id = 1032
// module chunks = 0